import React from 'react';
import logo from '../../images/logo.png';

const Logo = () => {
  return <img src={logo} alt="BG Live Logo" />;
};

export default Logo;
